import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'
import { Spinner } from '../spinner'

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	loading?: boolean
	leftIcon?: React.ReactNode // React node for the left icon
	rightIcon?: React.ReactNode // React node for the right icon
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, loading, type, leftIcon, rightIcon, ...props }, ref) => {
		return (
			<div className="relative w-full">
				{leftIcon && (
					<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
						{leftIcon}
					</div>
				)}
				<input
					type={type}
					className={cn(
						'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 lg:text-sm',
						{
							'pl-10': leftIcon, // Add padding-left if there is a left icon
							'pr-10': rightIcon, // Add padding-right if there is a right icon
						},
						className,
					)}
					ref={ref}
					{...props}
				/>
				{loading && (
					<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
						<div className="h-5 w-5 text-gray-500" aria-hidden>
							<Spinner showSpinner />
						</div>
					</div>
				)}
				{rightIcon && (
					<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
						{rightIcon}
					</div>
				)}
			</div>
		)
	},
)
Input.displayName = 'Input'

export { Input }
